import { Component } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';
import { RachatDisinvestmentFormComponent } from './rachat-disinvestment-form.component';

@UntilDestroy()
@Component({
  selector: 'rachat-programmed-disinvestment-form',
  templateUrl: './rachat-disinvestment-form.component.html',
  styleUrls: ['./rachat-disinvestment-form.component.scss'],
  standalone: false,
})
export class RachatProgrammedDisinvestmentFormComponent extends RachatDisinvestmentFormComponent {
  protected override get formOptions(): any {
    return { programmed: true };
  }
}
